



















import { computed, defineComponent, getCurrentInstance } from '@vue/composition-api';

import tips from '@/renderer/scripts/utils/tips';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import vistor from '@/renderer/scripts/utils/vistor';
import { CONSTANT_URL } from '@/renderer/scripts/http';

export default defineComponent({
  components: {},
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const vistorPhoneNumber = computed(() => vm.$store.getters.vistorPhoneNumber);
    const methods = {
      signOut() {
        try {
          vistor.onLogout();
        } catch (e: MsgError) {
          tips.error(e);
        }
      },
      // 打开产品反馈页
      openProductFeedbackPage() {
        dispatchRouter(CONSTANT_URL.productFeedbackUrl);
      },
    };
    return {
      vistorPhoneNumber,
      ...methods,
    };
  },
});
